module.exports = __webpack_public_path__ + "static/media/webbg.80fa5a7c.jpg";